// Reads one of VERA's answers aloud with Azure Speech (a multilingual neural voice).

import { useEffect, useRef, useState } from "react";
import { Icon, useStudio } from "./ui";
import { speak } from "../lib/speech";
import { L } from "../lib/i18n";

export function ReadAloud({ text }: { text: string }) {
  const { getToken, toast } = useStudio();
  const [state, setState] = useState<"idle" | "loading" | "playing">("idle");
  const stop = useRef<(() => void) | null>(null);
  useEffect(() => () => stop.current?.(), []);

  async function toggle() {
    if (state !== "idle") { stop.current?.(); stop.current = null; setState("idle"); return; }
    setState("loading");
    try {
      stop.current = await speak(getToken, text, () => { stop.current = null; setState("idle"); });
      setState("playing");
    } catch (e) { setState("idle"); toast(e instanceof Error ? e.message : L("Reading aloud didn't work.", "Leximi me zë nuk funksionoi.")); }
  }

  return (
    <button type="button" className="linkbtn readaloud" onClick={() => void toggle()} aria-pressed={state !== "idle"} title={state === "idle" ? L("Read aloud", "Lexoje me zë") : L("Stop", "Ndalo")}>
      <Icon name={state === "idle" ? "wave" : "stop"} size={13} /> {state === "loading" ? L("Preparing…", "Po përgatitet…") : state === "playing" ? L("Stop", "Ndalo") : L("Read aloud", "Lexoje me zë")}
    </button>
  );
}
